import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'newLine',
    standalone: true
})
export class NewLinePipe implements PipeTransform {
  transform(
    text: string | null,
    separator = ', ',
    newLineCharacter = '\n'
  ): any {
    return text ? text.split(newLineCharacter).join(separator) : '';
  }
}
